<app-esqueleto-tableros>
	<div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

	<app-filters filtros
		[name]="'filtros.per' | translate"
		[array]="aniosDisponibles"
		[typeFilter]="Filters.PERIOD"
		(eventClick)="cambioAnio($event)">
	</app-filters>

	<app-filters filtros
    [name]="'filtros.pers' | translate" 
    [array]="perspectives"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="todasPer"
    (eventClick)="cambioPer($event)"
  />

	<div contenido class="contenidoClass">
		<app-contenedor-elementos [header]="{
			title: 'gestion.seguimiento.estrategias.titulo' | translate,
			subtitles: [{text: Periodo}]
		}">

		<mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}"
			[matMenuTriggerFor]="menutabla">more_vert</mat-icon>
		<mat-menu #menutabla="matMenu">
			<button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
				<mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
				<span>{{'gestion.seguimiento.estrategias.exportar' | translate}}</span>
			</button>
		</mat-menu>

		<div body class="zonaTabla">
			@if (viewTabla) {
				<table class="tabla-aleema">
					<thead>
						<tr>
							<th class="textoOverFlow">
								{{ 'gestion.seguimiento.estrategias.titTab1' | translate }}
							</th>
							<th class="textoOverFlow">
								{{ 'gestion.seguimiento.estrategias.titTab2' | translate }}
							</th>
							<th class="textoOverFlow">
								<span>{{ 'gestion.seguimiento.estrategias.estrategia' | translate }}</span>
							</th>
							<th class="textoOverFlow">
								{{ 'gestion.seguimiento.estrategias.titTab3' | translate }}
							</th>
							<th class="textoOverFlow">
								{{ 'gestion.seguimiento.estrategias.titTab4' | translate }}
							</th>
						</tr>
					</thead>
					<tbody>
						@for(pro of programasMostrar; track pro.id; let i = $index) {
							<tr>
								<td [ngClass]="escribirPer(pro.programa,i) != ''? 'borderSup':''" class="textoOverFlow"
								style="max-width: 8vw;" matTooltip="{{escribirPer(pro.programa, i)}}">
									{{escribirPer(pro.programa,i)}}
								</td>
								<td [ngClass]="escribirPer(pro.programa,i) != ''? 'borderSup':''" class="textoOverFlow"
								matTooltip="{{escribirObj(pro.programa)}}"
								style="max-width: 10vw;">
									{{escribirObj(pro.programa)}}
								</td>
								<td [ngClass]="escribirPer(pro.programa,i) != ''? 'borderSup':''" class="textoOverFlow"
								matTooltip="{{pro.programa.name}}">
									{{pro.programa.name}}
								</td>
								<td [ngClass]="escribirPer(pro.programa,i) != ''? 'borderSup':''">
									{{avanceProg(pro, 'plan')}}
								</td>
								<ng-container>
									@if(avanceProg(pro, 'eje') !== 0) {
										<td [ngClass]="[escribirPer(pro.programa,i) != ''? 'borderSup':'', pintarBordPro(avanceProg(pro, 'eje'),avanceProg(pro, 'pla'))]"
										class="numerosAnch w3-center" style="cursor: pointer;" (dblclick)="openModal(pro)">
											{{avanceProg(pro, 'eje')}}
										</td>
									}
									@if(avanceProg(pro, 'eje') === 0) {
										<td [ngClass]="[escribirPer(pro.programa,i) != ''? 'borderSup':'', pintarBordPro(avanceProg(pro, 'eje'),avanceProg(pro, 'pla'))]"
										class="numerosAnch w3-center" style="cursor: pointer;" (dblclick)="openModal(pro)">
											{{avanceProg(pro, 'eje')}}
										</td>
									}
								</ng-container>
							</tr>
						}
					</tbody>
				</table>
			}@else {
				<div class="w3-row" style="height: 75vh;">
					<app-skeleton-table/>
				</div>
			}
		</div>

		</app-contenedor-elementos>
	</div>

</app-esqueleto-tableros>
<!-- MODALES  -->
<app-modal [isOpen]="modal1" [click]="false" (close)="closeModal()">

	<div modal-header>
		<span class="w3-margin-left-contenido"> {{ 'gestion.seguimiento.estrategias.proyAsociados' | translate }} </span>
	</div>

	<div modal-body>
		<div class="tablaModal" style="width: 80vw;">
			<table class="tabla-aleema">
				<thead>
					<tr>
						<th class="textoOverFlow anchos" style="min-width: 30vw; max-width: 30vw">
							{{ 'gestion.seguimiento.estrategias.proyecto' | translate }}
						</th>
						<th class="textoOverFlow"> {{'gestion.seguimiento.estrategias.inicio' | translate }} </th>
						<th class="textoOverFlow"> {{'gestion.seguimiento.estrategias.dias' | translate }} </th>
						<th class="textoOverFlow"> {{'gestion.seguimiento.estrategias.fin' | translate }} </th>
						<th class="textoOverFlow"> {{'gestion.seguimiento.estrategias.lider' | translate }} </th>
						<th class="textoOverFlow"> {{'gestion.seguimiento.estrategias.planeado' | translate }} </th>
						<th class="textoOverFlow"> {{'gestion.seguimiento.estrategias.ejecutado' | translate }} </th>
					</tr>
				</thead>
				<tbody>
					@for(pro of actividades; track pro.id) {
						@if(existPro(pro)) {
							<tr>
								<td class="textoOverFlow alingIzq" style="min-width: 30vw; max-width: 30vw">
									@if(!pro.check) {
										<mat-icon (click)="oculMost(pro)" class="w3-margin-right-contenido w3-button"
										matTooltip="{{ 'gestion.seguimiento.estrategias.expandir' | translate }}"
										[ngStyle]="{'color':'gray'}">expand_more</mat-icon>
									}
									@if(pro.check) {
										<mat-icon (click)="oculMost(pro)" class="w3-margin-right-contenido w3-button"
											matTooltip="{{ 'gestion.seguimiento.estrategias.contraer' | translate }}"
											[ngStyle]="{'color':'gray'}">expand_less</mat-icon>
									}
									{{pro.name}}
								</td>
								<td class="textoOverFlow">{{escFechPro(pro,'fi')}} </td>
								<td class="textoOverFlow">{{escFechPro(pro,'di')}} </td>
								<td class="textoOverFlow">{{escFechPro(pro,'ff')}} </td>
								<td class="textoOverFlow">
									<span matTooltip="{{escResp(pro.responsable)}}">{{escResp(pro.responsable)}}</span>
								</td>
								<td> {{escribirDatPro(pro,'plan')}} </td>
								<td [ngClass]="pintarBordPro(escribirDatPro(pro, 'ejec'),escribirDatPro(pro, 'plan'))">
									{{escribirDatPro(pro,'ejec')}} </td>
							</tr>
							@if(pro.check) {
								@for(act of pro.activities; track act.id) {
									@if(existAct(act)) {
										<tr>
											<td class="alingIzq textoOverFlow" style="min-width: 30vw; max-width: 30vw">
												<span matTooltip="{{act.name}}"> {{act.name}} </span>
											</td>
											<td class="anchoDias textoOverFlow">
												{{escFech(act.initial_date)}} </td>
											<td class="anchoDias textoOverFlow">
												{{diasTot(act.initial_date, act.end_date)}} </td>
											<td class="anchoDias textoOverFlow">
												{{escFech(act.end_date)}} </td>
											<td class="anchoResp textoOverFlow">
												<span matTooltip="{{escResp(act.responsible)}}">{{escResp(act.responsible)}}</span>
											</td>
											<td> {{escribirDat(act.historico,'plan')}} </td>
											@if(escribirDat(act.historico, 'ejec') !== null) {
												<td [ngClass]="pintarBord(escribirDat(act.historico, 'ejec'),escribirDat(act.historico, 'plan'))">
													{{escribirDat(act.historico, 'ejec')}}
												</td>
											}
											@if(escribirDat(act.historico, 'ejec') === null) {
												<td [ngClass]="pintarBord(escribirDat(act.historico, 'ejec'),escribirDat(act.historico, 'plan'))"
													class="borderAllLow textoAyud">
													0
												</td>
											}
										</tr>
									}
								}
							}
						}
					}
				</tbody>
			</table>
		</div>
	</div>

</app-modal>